import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';
import Button from './Button.jsx';

/**
 * Écran de verrou plein écran. Sans `failed` ni `busy` (simple masquage en arrière-plan),
 * il n'affiche que le titre.
 */
export default function LockScreen({ failed = false, busy = false, onUnlock, showActions = true }) {
  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-label="Application verrouillée"
      className="fixed inset-0 z-[100] bg-slate-50 flex items-center justify-center px-4"
    >
      <div className="w-full max-w-sm text-center space-y-6">
        <div>
          <div className="mx-auto mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-slate-800 text-white">
            <Lock size={26} aria-hidden="true" />
          </div>
          <p className="text-xs font-bold uppercase tracking-widest text-slate-400 mb-1">Treasury</p>
          <h1 className="text-xl font-bold text-slate-900">Legendary Parts</h1>
        </div>

        {showActions && (
          <div className="space-y-3">
            {failed && (
              <p className="text-sm text-slate-600">Déverrouillage annulé ou impossible.</p>
            )}
            <Button
              className="w-full py-3"
              onClick={onUnlock}
              loading={busy}
            >
              Déverrouiller avec Face ID
            </Button>
            <Link
              to="/login"
              state={{ password: true }}
              className="block text-sm text-slate-600 underline"
            >
              Utiliser le mot de passe
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
